import { useMemo } from 'react';
import { useGetCatalogQuery, useGetReleasesQuery } from '../../../redux/api/fymAPI';
import { useUserToken } from '../../../redux/slices/appInfo/hooks';
import { DEMO_ACCOUNT_ID } from '../../accountSelector/demoAccounts';
import { pickDemoSongUuid } from './tourRoutes';

/**
 * The uuid of the LaziiBee song that the kit and plan stops open ("Forests"). An empty string
 * while the demo catalog loads, or when `enabled` is false. These are reads only.
 */
export function useDemoSongUuid(enabled: boolean): string {
  const token = useUserToken();
  const skip = !enabled || token === null || token === '';
  const catalog = useGetCatalogQuery({ accountId: DEMO_ACCOUNT_ID }, { skip });
  const releases = useGetReleasesQuery({ accountId: DEMO_ACCOUNT_ID }, { skip });
  return useMemo(
    () => pickDemoSongUuid(catalog.data?.items ?? [], releases.data?.releases ?? []),
    [catalog.data, releases.data]
  );
}
